













































import Vue from 'vue';
import {
  AccountSubscriber,
  SubscribedUsersTableElement,
  UnsubscribedUsersTableElement,
  User,
} from '../../types';
import InviteAndSubscribeUserBtn from './InviteAndSubscribeUserBtn.vue';
import SubscribedUsersTable from './SubscribedUsersTable.vue';
import UnsubscribedUsersTable from './UnsubscribedUsersTable.vue';

export default Vue.extend({
  props: {
    parentId: {
      type: String,
      required: true,
    },
    accountId: {
      type: String,
      required: true,
    },
    hideInvite: {
      type: Boolean,
      default: false,
    },
    inviteBtnLabel: String,
  },
  methods: {
    subscribed(accountSubscriber: AccountSubscriber): void {
      (this.$refs.subscribedUsersTable as SubscribedUsersTableElement).add(accountSubscriber);
    },
    unsubscribed(user: User): void {
      (this.$refs.unsubscribedUsersTable as UnsubscribedUsersTableElement).add(user);
    },
  },
  components: {
    InviteAndSubscribeUserBtn,
    SubscribedUsersTable,
    UnsubscribedUsersTable,
  },
});
